// ==============================================
// DK Cart "Combineer met" — ADD knop (delegated, werkt ook na drawer refresh)
// ==============================================
(function () {
  'use strict';

  // --------------------------------------------------
  // ADD-knop: AJAX add to cart → refresh drawer
  // --------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.dk-cm-add-btn');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓';
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }, 500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = original;
      });
  });

})();
